import Constants from 'expo-constants';

/**
 * In dev, a physical device can't reach `127.0.0.1`/`localhost` — those resolve
 * to the phone itself. Rewrite loopback backend URLs to the Metro dev host (the
 * dev machine's LAN IP, which Expo exposes via `hostUri`, e.g. "192.168.1.5:8081").
 * No-op in production (`__DEV__` false) and for non-loopback URLs, so shipped
 * URLs are untouched; also a no-op on web, where `hostUri` is `localhost` and
 * loopback works anyway.
 */
export function resolveDevHost(url: string): string {
  if (!__DEV__) return url;
  const host = Constants.expoConfig?.hostUri?.split(':')[0]; // strip ":8081"
  if (!host || host === 'localhost' || host === '127.0.0.1') return url;
  return url.replace(/(\/\/)(127\.0\.0\.1|localhost)/, `$1${host}`);
}
